var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive } ],attrs:{"data-app":""}},[_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('div',{staticClass:"user",staticStyle:{"margin-top":"10%"}},[_c('img',{staticStyle:{"display":"block","margin":"auto","padding":"0 60px"},attrs:{"src":_vm.sidebarLogo}})]),_c('user-menu'),_c('mobile-menu'),_c('template',{slot:"links"},[((_vm.isDashboardSelect(_vm.tenant) || _vm.isYara) && (!_vm.isIma && !_vm.isIpmc && !_vm.isSesam) && (_vm.validateRoles('/visao-geral') || _vm.validateRoles('/eficiencia')))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.dashboard'),
          icon: 'grid-large',
        }}},[((_vm.isDashboardSelect(_vm.tenant) || _vm.isYara) && _vm.validateRoles('/visao-geral'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.overview'),
            slug: 'configuracoes',
            img: true,
            path: '/visao-geral',
          }}}):_vm._e(),((_vm.isDashboardSelect(_vm.tenant) || _vm.isYara) && _vm.validateRoles('/eficiencia'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.efficiency'),
            slug: 'configuracoes',
            img: true,
            icon: 'finance',
            path: '/eficiencia',
          }}}):_vm._e()],1):_vm._e(),(_vm.validateRoles('/historico-conversas') && (!_vm.isIma && !_vm.isIpmc && !_vm.isSesam))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.chatHistory'),
          icon: 'history',
          path: '/historico-conversas',
        }}}):_vm._e(),( (!_vm.isIma && !_vm.isIpmc && !_vm.isSesam) && _vm.searchMessageDashboard (_vm.tenant) && _vm.validateRoles('/busca-por-mensagens'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.searchMessages'),
          icon: 'account-search',
          path: '/busca-por-mensagens',
        }}}):_vm._e(),((_vm.isInss || _vm.isDataPrev || _vm.isDemo || _vm.isCedae || _vm.isSefMg || _vm.isYara || _vm.isYaraLtm || _vm.isDanese || _vm.isEds || _vm.isExtreme) && (!_vm.isIma && !_vm.isIpmc && !_vm.isSesam))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('curatorship.curatorship'),
          icon: 'filter',
        }}},[(_vm.validateRoles('/curadoria'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('curatorship.dashboard'),
            icon: 'grid-large',
            path: '/curadoria',
          }}}):_vm._e(),(_vm.validateRoles('/mensagens-nao-entendidas'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.messagesNotUnderstood'),
            icon: 'message-bulleted-off',
            path: '/mensagens-nao-entendidas',
          }}}):_vm._e()],1):_vm._e(),((_vm.isInss || _vm.isDemo || _vm.isCedae || _vm.isSefMg || _vm.isYara || _vm.isYaraLtm || _vm.isExtreme) && (!_vm.isIma && !_vm.isIpmc && !_vm.isSesam) && _vm.validateRoles('/analise-por-servico-entregue'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.analysisPerServiceDelivered'),
          icon: 'chart-box-outline',
          path: '/analise-por-servico-entregue'
        }}}):_vm._e(),((!_vm.isIma && !_vm.isIpmc && !_vm.isSefMg && !_vm.isSesam && !_vm.isExtreme) && _vm.validateRoles('/jornada-do-operador'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.operatorsJourney'),
          icon: 'timeline-clock',
          path: '/jornada-do-operador',
        }}}):_vm._e(),((_vm.isInss || _vm.isDataPrev || _vm.isDemo) && (!_vm.isIma && !_vm.isIpmc && !_vm.isSesam) && _vm.validateRoles('/auditoria-atendimento'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.eventAuthHistory'),
          icon: 'account-box-multiple',
          path: '/auditoria-atendimento',
        }}}):_vm._e(),((_vm.isDataPrev || _vm.isSefMg || _vm.isDemo) && (!_vm.isIma && !_vm.isIpmc && !_vm.isSesam) && _vm.validateRoles('/log-acesso'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.accessLog'),
          icon: 'account-clock',
          path: '/log-acesso',
        }}}):_vm._e(),((_vm.isInss || _vm.isDemo) && (!_vm.isIma && !_vm.isIpmc && !_vm.isSesam) && _vm.validateRoles('/historico-produtividade'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.productivityHistory'),
          icon: 'account-details',
          path: '/historico-produtividade',
        }}}):_vm._e(),((!_vm.isIma && !_vm.isIpmc && !_vm.isSesam && !_vm.isExtreme) && _vm.validateRoles('/templates'))?_c('sidebar-item',{attrs:{"link":{name: _vm.$t('drawer.proactiveNotification'), icon: 'bell'}}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.templates'),
            icon: 'message-reply',
            path: '/templates',
          }}}),(_vm.validateRoles('/campanha-desempenho-geral'))?_c('sidebar-item',{attrs:{"link":{
            customIcon: true,
            name: _vm.$t('drawer.campaignPerformance'),
            path: '/campanha-desempenho-geral',
          }}}):_vm._e(),(_vm.validateRoles('/campanhas'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.campaign'),
            icon: 'bullhorn',
            path: '/campanhas',
          }}}):_vm._e(),(_vm.validateRoles('/lista-campanhas'))?_c('sidebar-item',{attrs:{"link":{
            customIcon: true,
            name: _vm.$t('drawer.campaignFiredList'),
            path: '/lista-campanhas',
          }}}):_vm._e()],1):_vm._e(),((_vm.isIma || _vm.isIpmc || _vm.isSesam) && _vm.validateRoles('/templates'))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('drawer.templates'),
        icon: 'message-reply',
        path: '/templates',
      }}}):_vm._e(),((_vm.isIma || _vm.isIpmc || _vm.isSesam) && _vm.validateRoles('/campanha-desempenho-geral'))?_c('sidebar-item',{attrs:{"link":{
        customIcon: true,
        name: _vm.$t('drawer.campaignPerformance'),
        path: '/campanha-desempenho-geral',
      }}}):_vm._e(),((_vm.isIma || _vm.isIpmc || _vm.isSesam) && _vm.validateRoles('/campanhas'))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('drawer.campaign'),
        icon: 'bullhorn',
        path: '/campanhas',
      }}}):_vm._e(),((_vm.isIma || _vm.isIpmc || _vm.isSesam) && _vm.validateRoles('/lista-campanhas'))?_c('sidebar-item',{attrs:{"link":{
        customIcon: true,
        name: _vm.$t('drawer.campaignFiredList'),
        path: '/lista-campanhas',
      }}}):_vm._e(),((_vm.isIma || _vm.isIpmc || _vm.isSesam))?_c('sidebar-item',{attrs:{"link":{
        customIcon: true,
        name: _vm.$t('activeContacts.activeContacts'),
        path: '/contatos-ativos',
      }}}):_vm._e(),((!_vm.isIma && !_vm.isIpmc && !_vm.isSesam) && (_vm.validateRoles('/workspaces') || (_vm.validateRoles('/edicao-simplificada') && (_vm.isDemo || _vm.isRegularize))))?_c('sidebar-item',{attrs:{"link":{
          name: 'Chat Builder',
          icon: 'lan',
          path: '/snapshots',
        }}},[((!_vm.$route.meta.hideFooter ) && _vm.validateRoles('/workspaces'))?_c('sidebar-item',{attrs:{"link":{
            name:  'Workspaces',
            icon: 'folder-multiple',
            path: '/workspaces',
          }}}):_vm._e(),((!_vm.$route.meta.hideFooter ) && _vm.validateRoles('/edicao-simplificada') && (_vm.isDemo ||
            _vm.isRegularize))?_c('sidebar-item',{attrs:{"link":{
            name:  _vm.$t('drawer.simplifiedEditingChatbuilder'),
            icon: 'playlist-edit',
            path: '/edicao-simplificada',
          }}}):_vm._e()],1):_vm._e(),((_vm.validateRoles('/configuracoes-usuario-perfil') || _vm.validateRoles('/users')) && (_vm.isDemo ||
            _vm.isRegularize))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('managementAccess.AccessManagement'),
          slug: 'gestao',
          img: true,
        }}},[(_vm.validateRoles('/configuracoes-usuario-perfil') && (_vm.isDemo ||
            _vm.isRegularize))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('managementAccess.usersProfile'),
            path: '/configuracoes-usuario-perfil',
          }}}):_vm._e(),(_vm.validateRoles('/users') && (_vm.isDemo ||
            _vm.isRegularize))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('managementAccess.users'),
            path: '/users',
          }}}):_vm._e()],1):_vm._e(),(!_vm.isIma && !_vm.isIpmc && !_vm.isSesam)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('drawer.settings.title'),
          slug: 'configuracoes',
          img: true,
        }}},[(_vm.validateRoles('/canal-web'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.units.subitems.webChannel'),
            path: '/canal-web',
          }}}):_vm._e(),(_vm.validateRoles('/consulta-usuario-teams') && _vm.isDemo)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.verifyTeamsUserService'),
            path: '/consulta-usuario-teams',
          }}}):_vm._e(),(_vm.validateRoles('/lista-assistentes'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.settings.subitems.assistantList'),
            slug: 'configuracoes',
            img: true,
            path: '/lista-assistentes',
          }}}):_vm._e(),(_vm.hiddenProvider && _vm.validateRoles('/provider-autenticacao'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('drawer.authentications.subitems.authentications'),
            slug: 'autenticacoes',
            img: true,
            path: '/provider-autenticacao',
          }}}):_vm._e()],1):_vm._e()],1)],2),_c('div',{staticClass:"main-panel fixBackground"},[_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter && !_vm.isIma && !_vm.isIpmc && !_vm.isSesam)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }